export default function HWY_Step() {
    var data = {};

    this.init = () => {
        if( ! document.querySelector('.fellowship-step-page') ) {
            return;
        }
        loadDefault();
        showFinalStep();
        handleSelect();
        handleStepBar();
    }

    const loadDefault = () => {
        if( document.querySelector('.fellowship-step-page') ) {
            for (const iterator of dataFellowship.bottles ) {
                const item = jQuery('.step-bottles .step-product-wrap .product-product-item.' + iterator);
                item.addClass('show-option');
                const min = dataFellowship[iterator].min_price.sort((a, b) => Number(a) - Number(b) )[0];
                const max = dataFellowship[iterator].max_price.sort((a, b) => Number(b) - Number(a) )[0];
                let price = "$" + min + "-" + "$" + max;
                if( min == max ) {
                    price =  "$" + max;
                }
                item.find('.product-price').text(price);
            }
        }
    }

    const handleStepStyle = () => {
        let bottles = data.bottles;
        for (const iterator of dataFellowship[bottles]?.style ) {
            const item = jQuery('.step-style .step-product-wrap .product-product-item.' + iterator);
            item.addClass('show-option');
            const min = dataFellowship[bottles]?.style_min_price[iterator]?.sort((a, b) => Number(a) - Number(b) )[0];
            const max = dataFellowship[bottles]?.style_max_price[iterator]?.sort((a, b) => Number(b) - Number(a) )[0];
            let price = "$" + min + "-" + "$" + max;
            if( min == max ) {
                price =  "$" + max;
            }
            item.find('.product-price').text(price);
        }
    }

    const handleWineSelection = () => {
        let bottles = data.bottles;
        let style = data.style;
        if(style && bottles)
        for (const iterator of dataFellowship[bottles]?.wine_selection[style] ) {
            if("none" === iterator ) {
                data['win-selection'] = iterator;
                handleFinalItem();
            } else {
                const item = jQuery('.step-win-selection .step-product-wrap .product-product-item.' + iterator);
                item.addClass('show-option');
                const min = dataFellowship[bottles]?.product_info[style][iterator]?.price.min_price;
                const max = dataFellowship[bottles]?.product_info[style][iterator]?.price.max_price;
                let price = "$" + min + "-" + "$" + max;
                if( min == max ) {
                    price =  "$" + max;
                }
                item.find('.product-price').text(price);
            }
        }
    }
    
    const handleFinalItem = () => {
        let bottles = data.bottles;
        let style = data.style;
        let wine = data['win-selection'];
        const item = jQuery('.step-final .step-product-wrap .product-product-item');
        item.addClass('show-option');

        const min = dataFellowship[bottles]?.product_info[style][wine]?.price.min_price;
        const max = dataFellowship[bottles]?.product_info[style][wine]?.price.max_price;
        const name = dataFellowship[bottles]?.product_info[style][wine]?.product_name;
        const link = dataFellowship[bottles]?.product_info[style][wine]?.product_link;
        let price = "$" + min + "-" + "$" + max;
        if( min == max ) {
            price =  "$" + max;
        }

        item.find('.product-price').text(price);
        item.find('.product-title').text(name);
        item.find('.hwy-text-block-button a').attr('href',link);
    }

    const handleSelect = () => {
        jQuery('.step-section .step-section-item .hwy-text-block-button button').click( function(e) {
            if( data.bottles )
                handleStepStyle();

            if( data.style )
                handleWineSelection();

            if( data['win-selection'] )
                handleFinalItem();
            
            let showSection = jQuery(this).closest('.step-section-item').next();
            if(showSection.hasClass('step-win-selection') && "none" == data['win-selection'] ) {
                showSection = showSection.next();
            }
            const index = showSection.index();
            if( index !== -1 ) {
                jQuery('.step-section .step-section-item').removeClass('active');
                showSection.addClass('active');
                jQuery('.step-wrap .step-item ').eq( index ).addClass('active');
                activeStep();
            }
        } )
    }

    const handleStepBar = () => {
        jQuery('.step-wrap .step-item').click( function() {
            const index = jQuery(this).index();
            if( -1 !== index ) {
                jQuery(this).addClass('active');

                jQuery('.step-section .step-section-item').removeClass('active');
                jQuery('.step-section .step-section-item').eq( index ).addClass('active');
            }
        })
    }

    const showFinalStep = () => {
        if( document.querySelector('.fellowship-step-page') ) {
            jQuery('.fellowship-step-page .hwy-text-block-button button').click( function() {
                const type = jQuery( this ).data('type');
                const value = jQuery( this ).data('value');
                let step = ['bottles','style','win-selection','final'];
                let index = step.indexOf(type);
                if(-1 !== index && index < ( Object. keys(data).length - 1 )  ) {
                    for ( index; index < step.length; index++ ) {
                        const element = step[index];
                        if( 'final' !== element ) {
                            delete data[element];
                        }

                        jQuery('.step-wrap .' + element ).removeClass('active');
                        
                        if( 0 !== index )
                            jQuery('.step-section .step-' + element + ' .product-product-item' ).removeClass('show-option').removeClass('selected');
                    }
                }
                
                data[type] = value;
                jQuery('.step-' + type + ' .product-product-item' ).removeClass('selected');
                jQuery('.product-product-item.' + value ).addClass('selected');
            });
        }
    }

    const activeStep = () => {
        if( Object. keys(data).length > 0 ) {
            for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    if( "none" != data[key] )
                    jQuery('.step-wrap .' + key ).addClass('active');
                }
            }
        }
    }
}
    
